import React, { useRef } from "react";
import { MdOutlineArrowOutward } from "react-icons/md";
import { IoIosArrowForward } from "react-icons/io";
import bgImage from "../../assets/Home/bgfix.jpg";
import { energySectionData, solutionsData } from "../content/content";
import useGsapAnimations from "../../hooks/useGsapAnimations"; // Import GSAP hook
import { useNavigate } from "react-router-dom";

const EnergySection = () => {
  const navigate = useNavigate();
  const { heading, title, description, buttonLabel, items } = energySectionData;

  // Refs for animations
  const sectionRef = useRef(null);
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const solutionHeadingRef = useRef(null);
  const cardRefs = useRef([]);

  // Initialize GSAP animations
  useGsapAnimations({
    section: sectionRef,
    left: leftRef,
    right: rightRef,
    solutionHeading: solutionHeadingRef,
    cards: cardRefs,
  });

  return (
    <div>
      {/* Energy Section */}
      <div
        ref={sectionRef}
        className="relative w-full min-h-screen md:min-h-[88vh] flex flex-col md:flex-row items-center text-white"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-70"></div>

        {/* Content */}
        <div className="relative z-10 container mx-auto px-4 flex flex-col md:flex-row md:justify-between md:items-center p-6">
          {/* Left Section */}
          <div ref={leftRef} className="md:w-1/2 text-center md:text-left">
            <h3 className="text-sm uppercase tracking-wide text-start mb-2 text-yellow-400">
              {heading}
            </h3>
            <h1 className="text-xl sm:text-3xl md:text-5xl text-start font-bold leading-tight mb-4">
              {title}
            </h1>
            <p className="text-gray-200 text-sm text-start md:text-lg mb-6">
              {description}
            </p>
            <button
              onClick={() => (navigate("/synergy-dg"))}
              className="px-5 py-2 flex justify-start sm:px-6 sm:py-3 bg-yellow-400 text-black font-bold uppercase tracking-wide shadow-lg hover:bg-yellow-500 transition duration-300"
            >
              {buttonLabel}
            </button>
          </div>

          {/* Right Section */}
          <div ref={rightRef} className="mt-6 md:ml-4 ml-0 md:mt-0 md:w-1/2 w-full">
            <div className="space-y-4 md:space-y-6 w-full">
              {items.map((item, index) => (
                <div key={index} className="flex items-center space-x-4 text-gray-300 w-full">
                  {/* Icon */}
                  <div className="w-9 h-9 mt-[-80px] md:mt-[-30px] bg-yellow-400 text-black flex items-center justify-center rounded-full shrink-0">
                    <IoIosArrowForward className="text-xl font-bold" />
                  </div>

                  {/* Text */}
                  <div className="flex-1 pl-3">
                    <h4 className="text-lg font-bold text-white">{item.title}</h4>
                    <p className="text-sm leading-relaxed">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Our Solutions Section */}
      {/* <div ref={solutionHeadingRef} className="py-16 px-4">
        <div className="container mx-auto"> */}
          {/* Heading Section */}
          {/* <div className="mb-10 flex flex-col sm:block">
            <h1 className="text-2xl sm:text-4xl font-bold mb-3 sm:mb-4">
              {solutionsData.heading}
            </h1>
            <p className="text-gray-600 text-sm sm:text-base text-justify leading-relaxed sm:w-4/5">
              {solutionsData.description1}
            </p>
            <div className="mt-3 w-16 h-1 bg-yellow-400 sm:ml-0 ml-2"></div>
          </div> */}

          {/* Grid */}
          {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {solutionsData.items.map((solution, index) => (
              <div
                key={index}
                ref={(el) => (cardRefs.current[index] = el)}
                className={`relative p-6 ${solution.bgColor} bg-[#EFF0Ef] shadow-lg flex flex-col min-h-[270px]`}
              > */}
                {/* Icon at Top-Right */}
                {/* <div className="absolute top-0 bg-white w-20 h-20 right-0">
                  <div className="absolute top-0 right-0 hover:bg-slate-500 bg-yellow-300 w-[70px] h-[70px] flex items-center justify-center shadow shadow-white">
                    <MdOutlineArrowOutward className="text-black hover:text-white font-bold text-3xl" />
                  </div>
                </div> */}

                {/* Icon and Content */}
                {/* <div className="flex items-center justify-between">
                  <div className="p-4 border-4 border-dashed border-gray-400">
                    <img src={solution.image} alt={solution.title} className="w-12 h-12 object-contain" />
                  </div>
                </div> */}

                {/* <div className="mt-4">
                  <h3 className="text-lg font-bold mb-2">{solution.title}</h3>
                  <p className="text-gray-500 text-sm">{solution.description}</p>
                </div>
              </div> */}
            {/* ))}
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default EnergySection;
